import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Instagram, Facebook, ChevronLeft, ChevronRight } from 'lucide-react';
import Navbar from './components/Navbar';
import MainLayout from './layouts/MainLayout';
import AdminLayout from './layouts/AdminLayout';
import Login from './components/admin/Login';
import NotFound from './components/NotFound';
import Dashboard from './components/admin/Dashboard';
import ProtectedRoute from './components/admin/ProtectedRoute';
import PayRedirect from './components/PayRedirect';
import { ToastProvider } from './contexts/ToastContext';

function App() {
  return (
    <ToastProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="/" element={<MainLayout />} />
          <Route path="/kh-admin" element={<Navigate to="/kh-admin/login" replace />} />
          <Route path="/kh-admin/login" element={<Login />} />
          <Route
            path="/kh-admin/dashboard"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <Dashboard />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route path="/pay" element={<PayRedirect />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </ToastProvider>
  );
}

export default App;